const BrowserDetection = {
  methods: {
    isMobile: function () {
      return /iphone|ipod|ipad|android|blackberry|fennec/.test(
        navigator.userAgent.toLowerCase()
      );
    },
    // Firefox cannot load the 16k panorama textures
    isFirefox: function () {
      return navigator.userAgent.toLowerCase().includes("firefox");
    },
    isChromeBrowser: function () {
      // Check for Chromium-based browser
      const isChromium = !!window.chrome;

      // Ensure it's not Edge (Chromium-based Edge includes "Edg" in userAgent)
      const isEdge = navigator.userAgent.includes("Edg");

      // Ensure it's not Opera (which includes "OPR" in userAgent)
      const isOpera = navigator.userAgent.includes("OPR");

      // Chrome should have navigator.userAgentData
      const hasUserAgentData = navigator.userAgentData !== undefined;

      return isChromium && hasUserAgentData && !isEdge && !isOpera;
    }
  }
};

export default BrowserDetection;
